import React from "react";
import Reviewer from "./Reviewer";

function Institute(props) {


   if(!props.data || props.data.length === 0){
        return (
            <div className='text-center mt-10'>
                <h2 className='text-2xl font-bold'>No Institute Data Available</h2>
            </div>
        )
    }
    

  return (
    <div className="institute-con font-mono">
      <h3 className="bg-blue-950 text-white  mb-3 mt-2 text-center text-3xl">
        <b> Institute </b>
      </h3>
        <h4 className="capitalize p-4"><b>Current Qualification:</b> <span className="text-white bg-green-900 p-1 font-bold">{props.data.applying_for_type}</span></h4>
      <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con rounded-lg">
        <ul>
          <li>
            <b>Institution/University:</b> <span> { props.data.university === "OTHER" ? props.data.manual_university : props.data.university}</span>
          </li>
          <li>
            <b>Faculty:</b> <span> {props.data.faculty}</span>
          </li>
          <li>
            <b>Department:</b> <span> {props.data.deparment}</span>
          </li>
          <li>
            <b>Program:</b> <span>{props.data.deparment}</span>
          </li>
          <li>
            <b>Current Level:</b> <span>{props.data.current_level}</span>
          </li>
         

        
          <li>
            <b>Course of Study:</b> <span>{props.data.course_of_study}</span>
          </li>


          <li>
           
            <b>Year Of Admission:</b> <span>{props.data.year_of_admission}</span>
          </li>
          <li>
             <b>Graduation Year:</b> <span>{props.data.year_of_graduation}</span>
          </li>
            {
            props.applicationType === "loan" &&
            <>
            <li>
             <b>Have you applied for NELFUND Loan?:</b> <span>{props.data.nelfund_status}</span>
          </li>
          {props.data.nelfund_status === "Yes" &&
          <li>
             <b>If YES, indicate your loan Status:</b> <span>{props.data.nelfund_indicator }</span>
          </li>
          }
            </>
          }
     
          <li>
            <b>GPA:</b> <span>{props.data.gpa}</span>
          </li>
           
            {
                props.applicationType !== "loan" &&
          <li>
            <Reviewer />
          </li>
            }
        </ul>
      </div>
    </div>
  );
}

export default Institute;
